/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PortfolioCashAccountCreateRequest
 */
export interface PortfolioCashAccountCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    cashAccountId?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    cashAccountNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    currency: string;
    /**
     * 
     * @type {boolean}
     * @memberof PortfolioCashAccountCreateRequest
     */
    blocked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    relatedCustody?: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    accountType: string;
    /**
     * 
     * @type {string}
     * @memberof PortfolioCashAccountCreateRequest
     */
    accountStatus: string;
    /**
     * Marks the cash account as the Preferred Client Cash Account (PCCA) of the portfolio. Only one cash account per portfolio can be the PCCA; setting it on one account clears it on the others. When omitted on an existing account the current value is kept.
     * @type {boolean}
     * @memberof PortfolioCashAccountCreateRequest
     */
    pcca?: boolean;
}

/**
 * Check if a given object implements the PortfolioCashAccountCreateRequest interface.
 */
export function instanceOfPortfolioCashAccountCreateRequest(value: object): value is PortfolioCashAccountCreateRequest {
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('accountType' in value) || value['accountType'] === undefined) return false;
    if (!('accountStatus' in value) || value['accountStatus'] === undefined) return false;
    return true;
}

export function PortfolioCashAccountCreateRequestFromJSON(json: any): PortfolioCashAccountCreateRequest {
    return PortfolioCashAccountCreateRequestFromJSONTyped(json, false);
}

export function PortfolioCashAccountCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortfolioCashAccountCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'cashAccountId': json['cashAccountId'] == null ? undefined : json['cashAccountId'],
        'cashAccountNumber': json['cashAccountNumber'] == null ? undefined : json['cashAccountNumber'],
        'currency': json['currency'],
        'blocked': json['blocked'] == null ? undefined : json['blocked'],
        'relatedCustody': json['relatedCustody'] == null ? undefined : json['relatedCustody'],
        'accountType': json['accountType'],
        'accountStatus': json['accountStatus'],
        'pcca': json['pcca'] == null ? undefined : json['pcca'],
    };
}

export function PortfolioCashAccountCreateRequestToJSON(json: any): PortfolioCashAccountCreateRequest {
    return PortfolioCashAccountCreateRequestToJSONTyped(json, false);
}

export function PortfolioCashAccountCreateRequestToJSONTyped(value?: PortfolioCashAccountCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cashAccountId': value['cashAccountId'],
        'cashAccountNumber': value['cashAccountNumber'],
        'currency': value['currency'],
        'blocked': value['blocked'],
        'relatedCustody': value['relatedCustody'],
        'accountType': value['accountType'],
        'accountStatus': value['accountStatus'],
        'pcca': value['pcca'],
    };
}

